import React, { createContext, useContext } from 'react';
const FALLBACK = {};
const ExternalDataContext = /*#__PURE__*/createContext(undefined);
export const ExternalDataProvider = _ref => {
  let {
    children,
    externalData
  } = _ref;
  return /*#__PURE__*/React.createElement(ExternalDataContext.Provider, {
    value: externalData ?? FALLBACK
  }, children);
};
export function useExternalData() {
  const context = useContext(ExternalDataContext);
  if (context === undefined) {
    throw new Error('useExternalData must be used within a ExternalDataProvider');
  }
  return context;
}
//# sourceMappingURL=external-data-context.js.map